module.exports = __webpack_public_path__ + "static/media/MariaRebecaFelixRuiz.c67b8674.png";